export enum UserTypes {
  CITIZEN = 'CITIZEN'
}
